export default "__VITE_ASSET__92d9759e__"